"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncToGenerator2 = require("@babel/runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _regenerator = require("@babel/runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _optionProcessor = require("../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor");

var _optionProcessor2 = _interopRequireDefault(_optionProcessor);

var _core = require("@mpxjs/core");

function _interopRequireDefault(obj) {
    try {
        return obj && obj.__esModule ? obj : { default: obj };
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_interopRequireDefault@@../../../../src/views/index/test.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}

var wxsModules = {};
//
//
//
//
//
//

global.currentSrcMode = "wx";

(0, _core.createPage)({
  data: {
    mpxMode: __mpx_mode__,
    img: '',
    buttonText: ''
  },
  onLoad: function onLoad(option) {
    try {
        var _this = this;
        return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            try {
                var res;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    try {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                console.log('test onload');
                                res = {
                                    img: 'https://dpubstatic.udache.com/static/dpubimg/272328/head-img.jpg?x-s3-process=image/format,webp',
                                    buttonText: '测试页面2'
                                };
                                _this.img = res.img;
                                _this.buttonText = res.buttonText;
                            case 4:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    } catch (e)
                                                {
                            'use strict';
                            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                                try {
                                    JSON.stringify(k);
                                    return true;
                                } catch (e) {
                                    return false;
                                }
                            });
                            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee$@@../../../../src/views/index/test.mpx@@-1', -1, e.message, {
                                stack: e.stack,
                                arguments: omegaParams
                            }) : '';
                            throw e;
                        }
                }, _callee);
            } catch (e)
                                {
                    'use strict';
                    var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                        try {
                            JSON.stringify(k);
                            return true;
                        } catch (e) {
                            return false;
                        }
                    });
                    window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('_callee@@../../../../src/views/index/test.mpx@@-1', -1, e.message, {
                        stack: e.stack,
                        arguments: omegaParams
                    }) : '';
                    throw e;
                }
        }))();
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('onLoad@@../../../../src/views/index/test.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
},
  watch: {},
  computed: {},
  methods: {
    clickHandle: function clickHandle() {
    try {
        console.log('test');
        this.buttonText = 'test';
    } catch (e)
                {
            'use strict';
            var omegaParams = Array.prototype.slice.call(arguments).filter(function (k) {
                try {
                    JSON.stringify(k);
                    return true;
                } catch (e) {
                    return false;
                }
            });
            window['Omega'] && typeof Omega.trackError === 'function' ? Omega.trackError('clickHandle@@../../../../src/views/index/test.mpx@@-1', -1, e.message, {
                stack: e.stack,
                arguments: omegaParams
            }) : '';
            throw e;
        }
}
  }
});
var currentOption = global.currentOption;
exports.default = (0, _optionProcessor2.default)(currentOption, "page", "", "", {
  "navigationBarTitleText": "test",
  "backgroundColor": "#ffffff"
}, // @ts-ignore
{}, // @ts-ignore
{
  'Index': (0, _optionProcessor.getComponent)(require("../../components/pages/index.mpx?component=true&componentId=index7c39b0fb")),
  'mpx-view': (0, _optionProcessor.getComponent)(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), {
    __mpxBuiltIn: true
  })
}, undefined, {}, undefined, (0, _optionProcessor.getWxsMixin)(wxsModules));